/** Headers a new webhook starts with, from the legacy `WebhookForm`. */
export const DEFAULT_WEBHOOK_HEADERS = {
  "{{content_type}}": "application/json",
  "{{authorization}}": "",
};

/**
 * Body a new webhook starts with, from the legacy `WebhookForm`, plus
 * `company_social_reason` (the seller's company), which the backend has
 * filled in since 2026-10-31. It mirrors `Webhook.__template_body__` in
 * `deliveries/services/webhook.py`: the backend sends these keys even when
 * the client removes them here.
 */
export const DEFAULT_WEBHOOK_BODY = {
  "{{order_id}}": "{{order_id}}",
  "{{reference_id}}": "{{reference_id}}",
  "{{company_social_reason}}": "{{company_social_reason}}",
  "{{status}}": "{{status}}",
  "{{substatus}}": "{{substatus}}",
  "{{status_timestamp}}": "{{status_timestamp}}",
  "{{comments}}": "{{comments}}",
  "{{recipients}}": "{{recipients}}",
  "{{address}}": "{{address}}",
  "{{commune}}": "{{commune}}",
  "{{region}}": "{{region}}",
  "{{url_images}}": "{{url_images}}",
};

/**
 * Placeholders the backend fills in, as listed by the legacy
 * `getDefaultWebhookAttrs`. The legacy array had a stray empty slot after
 * `{{current_date}}` that rendered nothing; it is gone here.
 */
export const WEBHOOK_SYSTEM_ATTRS = [
  "{{order_id}}",
  "{{reference_id}}",
  "{{company_social_reason}}",
  "{{status}}",
  "{{substatus}}",
  "{{status_timestamps}}",
  "{{comments}}",
  "{{recipient_name}}",
  "{{recipient_phone}}",
  "{{recipient_email}}",
  "{{address}}",
  "{{street_number}}",
  "{{commune}}",
  "{{region}}",
  "{{url_images}}",
  "{{current_date}}",
  "{{order_notes}}",
];
